export const isDefined = <T>(argument: T | undefined): argument is T => argument !== undefined;
export const isNotNullish = <T>(argument: T | null | undefined): argument is T => argument != undefined;
